<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage customer</small>
      </legend>
      <div></div>
      <div>
        <div class="customersLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa spin" style="font-size: 24px; color: blue"></i>loading customers...
        </div>

        <vue-good-table
          :columns="columns"
          :rows="systemCustomers"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Edit'">
              <button
                v-b-tooltip.hover.bottom="'Edit customer!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewCustomer(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit Customer
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Email",
          field: "email_address",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter email"
          }
        },
        {
          label: "Address",
          field: "address",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter Address"
          }
        },

        {
          label: "Phone",
          field: "mobile_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter mobile number"
          }
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text"
        },
        {
          label: "Edit",
          field: "Edit",
          width: "122px",
          html: true
        }
      ]
    };
  },

  created() {
    this.loadCustomer();
  },
  computed: {
    ...mapGetters(["systemCustomers"])
  },
  methods: {
    ...mapActions(["loadCustomer", "viewCustomer", "fileCustomer"])
  }
};
</script>



// WEBPACK FOOTER //
// src/customers/managecustomers.vue